import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { jobLocationLabel } from '../../utils/jobLocation';
import Table from './Table';
//import { TalentRequestsList } from '../../mockData';
import { useGetAllHireRequestQuery } from '../../reactWrapper/Redux/apiSlice';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Pagination from '../Pagination/Pagination';
import { Button } from '../ui/button';
import CloseJobModal from '../Modal/CloseJobModal';
import Status from '../Status/Status';


const TalentRequestTable = () => {
  const siblingCount = 1;
  const pageColumn = 1;
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data } = useGetAllHireRequestQuery(page)
  const [selectedData, setIsSelectedData] = useState('')


  const handlePageChange = useCallback(
    (page) => {
      setPage(page - 1);
    },
    [page]
  );

  const tableHeader = useMemo(
    () => [
      {
        title: 'Company',
        key: 'company',
      },
      {
        title: 'Role',
        key: 'stack',
      },
      {
        title: 'Date',
        key: 'date',
      },
      {
        title: 'Location',
        key: 'location',
      },
            {
        title: 'Matching Accuracy',
        key: 'matching accuracy',
      },
      {
        title: 'Views',
        key: 'views',
      },
      {
        title: 'Status',
        key: 'status',
      },
      {
        title: 'Talents',
        key: 'view matched talent',
      },
      {
        title: '',
        key: 'details',
      },
    ],
    []
  );


  const getPercentage = (text) => {
  const match = text?.match(/\d+%/);
  return match ? match[0] : "";
};


  // console.log('Data passed:', data)

  const modifiedData = useMemo(() => {
    return data?.data?.map((each) => [
      <div className='flex gap-[18px] items-center'>
        <div className='w-11 h-11'>
          <img
            src={each?.companyLogo}
            alt='logo'
          />
        </div>
        <p>{each?.companyName}</p>
      </div>,
      each.stack,
      new Date(each?.postedDate).toLocaleDateString(),
      jobLocationLabel(each),
      
<p className="">{getPercentage(each?.matching_info)}</p>,
      <p className="font-semibold text-brand-navy">{each?.count_views || 0}</p>,
      <Status label={each?.status || 'N/A'} />,
  <Link
        className='text-sm inline-block rounded-lg border border-border py-[1.56px] px-[11.7px] text-muted-foreground '
        to={`matched-talents/${each?.id}`}
      >
        Matched Talents
      </Link>,
<div className="flex items-center gap-2">
      <Link
        className='text-sm inline-block rounded-lg border border-border py-[7.56px] px-[11.7px] text-muted-foreground '
        to={`client-details/${each?.id}`}
      >
        Details
      </Link>

   { each.status === 'open' && <Button 
        onClick={() => {
          setIsSelectedData(each)
          setIsModalOpen(true)
        }}
        className='text-sm inline-block rounded-lg border border-border
        py-[1px] px-[11.7px] text-white bg-red-600'
      >
        Close Job
      </Button>
      }
      </div>,
    
    ])
  })
  // console.log(data?.data?.at(0))

  useEffect(() => {
    setTotalCount(data?.total ?? 0);
  }, [data]);

  return (
    <div>
      <Table header={tableHeader} label="" column={modifiedData} />

      <section className="w-full py-5">
        <Pagination
          rangeStart={
            totalCount !== 0
              ? (page || 0) * ((pageSize || 0) * pageColumn) + 1
              : 0
          }
          totalCount={totalCount}
          currentPage={(page || 0) + 1}
          pageSize={pageSize}
          pageColumn={pageColumn}
          siblingCount={siblingCount}
          onPageChange={handlePageChange}
          className="pt-9"
        />


      </section>


{isModalOpen && 
 <CloseJobModal
 open={isModalOpen}
closeModal={() => setIsModalOpen(false)} 
data={selectedData}
 />}
      
        
       
     

    </div>
  );
};

export default TalentRequestTable;
